import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ProgressBarProps {
  current: number;
  total: number;
  onBack: () => void;
  onSkip: () => void;
}
export function ProgressBar({
  current,
  total,
  onBack,
  onSkip
}: ProgressBarProps) {
  const progress = (current + 1) / total * 100;
  return <div className="absolute top-0 left-0 w-full z-50" data-id="element-1541" data-mp="23l22mtpnfe4c">
      <div className="h-1 bg-navy-700 w-full" data-id="element-1542" data-mp="28lq1u2o1719n">
        <motion.div className="h-full bg-teal-400" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-1543" data-mp="2co376pyv8x5w" />
      </div>
      <div className="flex items-center justify-between px-6 pt-3 pl-44" data-id="element-1544" data-mp="2rczegkt3m65g">
        <button onClick={onBack} disabled={current === 0} className="flex items-center gap-1 text-sm font-medium text-white/50 hover:text-white transition-colors disabled:opacity-20 disabled:cursor-not-allowed" data-id="element-1545" data-mp="2rawcr3il2okw">
          <ChevronLeftIcon className="w-4 h-4" data-id="element-1546" data-mp="1xzl1cmdh24b8" />
          Back
        </button>
        <span className="text-xs font-medium text-white/40 tracking-widest" data-id="element-1547" data-mp="1t0hucwdxlo0m">
          {current + 1} / {total}
        </span>
        <button onClick={onSkip} disabled={current === total - 1} className="flex items-center gap-1 text-sm font-medium text-white/50 hover:text-white transition-colors disabled:opacity-20 disabled:cursor-not-allowed" data-id="element-1548" data-mp="1p07rhslfrdpz">
          Skip
          <ChevronRightIcon className="w-4 h-4" data-id="element-1549" data-mp="2bzdqid9coch3" />
        </button>
      </div>
    </div>;
}